import PageModule from "@eisinc/Overrides/Pages/RfqConfirmationPage";

export * from "@eisinc/Overrides/Pages/RfqConfirmationPage";

export default PageModule;
